import { FormattedMessage } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import TextButton from 'LuxKit/Button/TextButton'
import Sheet from 'components/utils/Sheet'

const Banner = styled(Sheet)`
  flex-shrink: 0;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: ${rem(8)};
`

const Message = styled(BodyText)`
  min-width: 0;
`

interface Props {
  onDismiss: () => void
}

/**
 * Warning banner shown across every Trip Planner chat surface (main chat and
 * offer-page assistant) when the account is spoofed, so staff always know
 * the chat they are creating or messaging in is hidden from the customer.
 * Mirrors StaffSpoofBanner's critical/inverse Sheet treatment and dismiss
 * interaction — the parent decides whether to render this, same as
 * StaffSpoofBanner.
 */
function PrivateChatBanner({ onDismiss }: Props) {
  return (
    <Banner
      className="no-print"
      background="critical"
      paletteType="inverse"
      padding={8}
    >
      <Message variant="medium" weight="bold" colour="normal-contrast" align="center">
        <FormattedMessage
          id="buWsl4nh2aQjIDBdBaUN"
          defaultMessage="This chat is private and cannot be viewed by the customer"
          description="Warning banner shown in spoof mode on every Trip Planner chat surface"
        />
      </Message>
      <TextButton kind="tertiary" size="small" onClick={onDismiss}>
        <FormattedMessage
          id="U7aBsnG60mj1Mvl7HWy1"
          defaultMessage="Dismiss"
          description="Button label that hides the private chat warning banner"
        />
      </TextButton>
    </Banner>
  )
}

export default PrivateChatBanner
